import HtmlContent from "../../../Common/HtmlContext";

import { Grid, styled } from "@mui/material";
import { X } from "@phosphor-icons/react";
import { useRecoilValue } from "recoil";
import { NoticeData } from "../../../../system/types/Notice";
import { ModalState, ModalStateType } from "../../../../system/Constants";
import { RoleCheckAtom } from "../../../../system/atoms";
import {
  AppliedItem,
  MainTitle,
  RaffleContent,
} from "../../../../styles/theme";
import { CustomText } from "../../../../styles/CustomText";
import { AccommodationNoticeIcon } from "../../../../styles/accommodationStyle";
import {
  CustomButtonGray,
  CustomButtonYellow,
} from "../../../../styles/button";

interface MeetingRoomNoticeDetailProps {
  handleClose: () => void;
  selectedNotice: NoticeData;
  setNoticeState: React.Dispatch<React.SetStateAction<ModalStateType>>;
}

function MeetingRoomNoticeDetail({
  handleClose,
  selectedNotice,
  setNoticeState,
}: MeetingRoomNoticeDetailProps) {
  const todayDate = new Date();
  const onChangeState = (state: string) => {
    setNoticeState(state);
  };
  const rolecheck = useRecoilValue(RoleCheckAtom);
  return (
    <Grid container item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RaffleContent>
            <MainTitle>회의실 공지사항 상세</MainTitle>
            <AppliedItem onClick={handleClose}>
              <X size={32} />
            </AppliedItem>
          </RaffleContent>
        </Grid>
      </Grid>
      <StyledNoticeBox container mt="20px">
        <StyledNoticeTable container alignItems="center">
          <CustomText type="subtitle" width="120px">
            제목
          </CustomText>
          {selectedNotice.mainStartDate &&
            new Date(selectedNotice.mainStartDate) < todayDate &&
            (selectedNotice.mainEndDate === null ||
              new Date(selectedNotice.mainEndDate) > todayDate) && (
              <AccommodationNoticeIcon
                src="/images/VEHICLE/mainSpeaker.png"
                alt="주요 공지사항"
                style={{ marginBottom: "-5px" }}
              />
            )}

          <Grid> {selectedNotice.title}</Grid>
        </StyledNoticeTable>
        <StyledNoticeTable container justifyContent="space-between">
          <Grid container item xs={12} sm={6}>
            <CustomText type="subtitle" width="120px">
              작성자
            </CustomText>
            {selectedNotice.createBy}
          </Grid>
          <Grid container item xs={12} sm={6}>
            <CustomText type="subtitle" width="120px">
              작성일
            </CustomText>
            {selectedNotice.createdAt}
          </Grid>
        </StyledNoticeTable>
        {rolecheck && (
          <StyledNoticeTable container justifyContent="space-between">
            <Grid container item xs={12} sm={6}>
              <CustomText type="subtitle" width="120px">
                주요 공지 시작
              </CustomText>
              {selectedNotice.mainStartDate
                ? selectedNotice.mainStartDate
                : "해당 사항 없음"}
            </Grid>
            <Grid container item xs={12} sm={6}>
              <CustomText type="subtitle" width="120px">
                주요 공지 종료
              </CustomText>
              {selectedNotice.mainEndDate
                ? selectedNotice.mainEndDate
                : "해당 사항 없음"}
            </Grid>
          </StyledNoticeTable>
        )}
        <StyledNoticeTable container>
          <CustomText type="subtitle" width="120px">
            내용
          </CustomText>
          <StyledTextBox>
            <HtmlContent
              data={
                selectedNotice.content
                  ? selectedNotice.content
                  : "작성된 내용이 없습니다."
              }
            ></HtmlContent>
          </StyledTextBox>
        </StyledNoticeTable>
        <Grid container justifyContent="center" mt="10px">
          {rolecheck && (
            <CustomButtonYellow
              onClick={() => {
                onChangeState("edit");
              }}
            >
              수정
            </CustomButtonYellow>
          )}
          <CustomButtonGray
            onClick={() => {
              onChangeState(ModalState.table);
            }}
          >
            목록으로
          </CustomButtonGray>
        </Grid>
      </StyledNoticeBox>
    </Grid>
  );
}

export default MeetingRoomNoticeDetail;

const StyledNoticeBox = styled(Grid)({
  borderTop: "1px solid #DCDFE3",
});

const StyledNoticeTable = styled(Grid)({
  borderBottom: "1px solid #DCDFE3",
  padding: "10px 5px",
});

const StyledTextBox = styled(Grid)({
  minHeight: "300px",
});
